<template>
  <div>
    <el-drawer
      :visible.sync="mDrawer"
      direction="btt"
      size="40%"
      >
      <div slot="title" class="m-draw-title">Refund Step</div>
      <div class="m-drawer">
          <el-steps direction="vertical" :active="1">
            <el-step title="步骤 1"></el-step>
            <el-step title="步骤 2"></el-step>
            <el-step title="步骤 3"></el-step>
          </el-steps>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 从下弹起drawer,进度条---移动端
export default {
  data() {
    return {
      mDrawer: false
    }
  }
}
</script>

<style lang="less" scoped>
.m-drawer{
  height: 90%;
  padding-left: 20px;
  padding-bottom: 10px;
}
.m-draw-title{
  text-align: center;
  font-size: 16px;
  font-family: Satoshi-medium;
  font-weight: 400;
  line-height: 18px;
  color: #000000;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/m-drawer.vue